import React from 'react';
import QuickSearchNoHit from './QuickSearch.NoHit';
import QuickSearchResultTab from './QuickSearchResultTab';
import QuickSearchResultTabItem from './utils/QuickSearchResult.TabItem';
import { QuickSearchResultItem } from '../../Types/QuickSearchResultItem';
import { EditorStringModel } from '../../Types/EditorString';
import clsx from 'clsx';

interface QuickSearchResultProps {
  searchUrl: string;
  activeTab?: string;
  noHitHeader: string;
  noHitDescription: EditorStringModel;
  totalNumResults: number;
  items?: QuickSearchResultItem[];
}

const QuickSearchResult = ({
  searchUrl,
  activeTab,
  noHitHeader,
  noHitDescription,
  items,
  totalNumResults,
}: QuickSearchResultProps) => {
  return (
    <div
      className={clsx(
        'container z-[55] h-screen w-full max-w-[1888px] rounded-b md:h-96 lg:px-6 xl:px-8',
        totalNumResults > 0 && 'md:h-[496px]'
      )}
    >
      <div>
        <ul className="-mr-4 flex list-none gap-4 overflow-x-auto pr-4 pt-6 scrollbar-none">
          {items?.map(
            (item, idx) =>
              item.items.length > 0 && (
                <QuickSearchResultTabItem
                  resultKey={item.key}
                  active={item.key == activeTab}
                  quantity={item.items.length}
                  key={idx}
                />
              )
          )}
        </ul>
        {totalNumResults > 0 &&
          items?.map(
            (item, idx) =>
              item.items.length > 0 &&
              item.key == activeTab && (
                <QuickSearchResultTab
                  modelKey={item.key}
                  results={item.items}
                  key={idx}
                />
              )
          )}
      </div>
      {totalNumResults == 0 && (
        <QuickSearchNoHit
          title={noHitHeader}
          description={noHitDescription}
        />
      )}
    </div>
  );
};

export default QuickSearchResult;
